import { app as teamsApp, authentication } from "@microsoft/teams-js";

/**
 * Running inside Microsoft Teams.
 *
 * The same build serves both the phone's home screen and the Teams tab. In
 * Teams, sign-in is single sign-on: Teams hands us an Entra token for the
 * signed-in hospital account, the server verifies it, and the clinician is in
 * with no passkey and nothing typed. Alerts inside Teams come from the bot,
 * not from Web Push, so the push prompt is hidden there.
 */

let initialised: Promise<boolean> | null = null;

/** True once Teams has answered; false if we are not framed by Teams. */
export function inTeams(): Promise<boolean> {
  if (initialised) return initialised;
  const hinted = new URLSearchParams(window.location.search).get("inTeams") === "1";
  const framed = window.parent !== window.self || window.name === "embedded-page-container" || hinted;
  if (!framed) return (initialised = Promise.resolve(false));
  initialised = Promise.race([
    teamsApp.initialize().then(() => true, () => false),
    new Promise<boolean>((r) => setTimeout(() => r(false), 4000)),
  ]);
  return initialised;
}

/** The Entra access token for page-com, from Teams, silently. */
export async function teamsToken(): Promise<string> {
  return authentication.getAuthToken({ silent: true });
}

export function teamsReady(): void {
  try { teamsApp.notifySuccess(); } catch { /* not in Teams */ }
}
